import handle from "./Axios"
import SWR_KEY from './swr/constant'

export const getList = () => {
  try {
    return handle.get(SWR_KEY.GET_TOKEN_LIST)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export const getFiatList = () => {
  try {
    return handle.get(SWR_KEY.GET_FIAT_LIST)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

const getAloWallet = (url: string) => {
  try {
    return handle.get(url).then(res => res.data.data)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export default { getList, getFiatList, getAloWallet }
